import * as React from "react"
import {map as _map} from "lodash"
import IStaticDataValue from "../../../common/models/IStaticDataValue";

import {ChangeEvent} from "react";
import IHabitNew from "../models/IHabitNew";

/**
 * Created by aditya on 20/02/18.
 */

export interface HabitQuestionItemProps {
    habitItem: IHabitNew,
    questionText: string,
    frequencyItems: IStaticDataValue[],
    yesByDefault?: boolean,
    onHabitChange: (frequency: string, name: string) => void,
    onHabitRemove: (name: string) => void
}

export interface HabitQuestionItemState {
    isYes: boolean
}

class HabitQuestionItem extends React.Component<HabitQuestionItemProps, HabitQuestionItemState> {

    constructor(props: HabitQuestionItemProps) {
        super(props);
        this.state = {
            isYes: props.yesByDefault !== undefined ? props.yesByDefault : false
        }
    }

    toggleYesNoStatus(flag: boolean) {
        this.setState({isYes: flag}, () => {
            if (!flag) this.props.onHabitRemove(this.props.habitItem.habitName)
            else this.props.onHabitChange(this.props.frequencyItems[0].internalValue, this.props.habitItem.habitName);
        })
    }

    onHabitFrequencyChange = (event: ChangeEvent<HTMLSelectElement>) => {
        this.props.onHabitChange(event.target.value, this.props.habitItem.habitName);
    }

    render() {
        let questionText = this.props.questionText;
        let frequencyItems = this.props.frequencyItems;
        let isYes = this.state.isYes;
        let habitFrequency = this.props.habitItem.frequency !== null ? this.props.habitItem.frequency : "";
        return (
            <div className="patient-habit-question-item-editor">
                <div className={"habit-question-container"}>{questionText}</div>
                <div className={"habit-yesOrNo-container"}>
                    <input type="button" value="Yes" className={`yesOrNoButton ${isYes ? "active" : ""}`} onClick={() => this.toggleYesNoStatus(true)}/>
                    <input type="button" value="No" className={`yesOrNoButton  ${!isYes ? "active" : ""}`} onClick={() => this.toggleYesNoStatus(false)}/>
                </div>
                <div className={"habit-comments-container"}>
                    <select onChange={this.onHabitFrequencyChange} className={isYes ? "active" : ""} disabled={isYes ? false : true} value={habitFrequency}>
                        { isYes ? null : <option>Select</option> }
                        {
                            _map(frequencyItems, (item, index) => {
                                return <option value={item.internalValue} key={`habit-frequency-item-${item.internalValue}`}>{item.displayValue}</option>
                            })
                        }
                    </select>
                </div>
            </div>
        );
    }
}

export default HabitQuestionItem